exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wizard-navigation ul {\n  display: flex;\n  list-style-type: none;\n  padding: 0; }\n  .wizard-navigation ul li {\n    flex: 1;\n    padding: 15px; }\n    .wizard-navigation ul li .wizard-navigation-btn {\n      background: #004466;\n      color: white;\n      padding: 15px;\n      border-radius: 3px;\n      cursor: pointer; }\n      .wizard-navigation ul li .wizard-navigation-btn:hover {\n        opacity: .8; }\n    .wizard-navigation ul li .disabled {\n      background: #aaaaaa !important;\n      opacity: .6; }\n      .wizard-navigation ul li .disabled:hover {\n        opacity: .6 !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scenes/WizardForm/components/WizardNavigation/style.scss
// module id = 598
// module chunks = 0